import React, {useEffect, useRef} from 'react';

function useInterval(callback, delay) {
    const savedCallback = useRef(callback);
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (delay === null) return;
        const timeout = setInterval(() => savedCallback.current(), delay);
        return () => clearTimeout(timeout);
    }, [delay]);
}

export {useInterval}
